import React from 'react'
import { HiReply } from 'react-icons/hi'
// import '../../layouts/stylesheets/insights-style.css';
import InsightResponseDetails from './InsightResponseDetails'
import {
  TRACKER_CLICK_INSIGHTS_BY_CITY,
  TRACKER_CLICK_INSIGHTS_BY_DEVICE,
  TRACKER_CLICK_INSIGHTS_BY_PLATFORM,
  TRACKER_CLICK_INSIGHTS_BY_DAY_OF_THE_WEEK,
  TRACKER_CLICK_INSIGHTS_BY_HOUR_OF_THE_DAY,
  MY_CAMPAIGNS_QUERY,
} from '../../services/GraphQLQueries'
import { sources } from '../Sources.jsx'

const InsightResponse = (props) => {
  const responses = {
    highestClick_platform: {
      query: TRACKER_CLICK_INSIGHTS_BY_PLATFORM,
      chartType: 'pie',
      text: '{0} received the highest number of ad clicks with {1} clicks.',
    },
    totalConversions_allCampaigns: {
      query: MY_CAMPAIGNS_QUERY,
      chartType: '',
      text: 'The total number of conversions across all campaigns was {0}.',
    },
    highestConversion_device: {
      query: TRACKER_CLICK_INSIGHTS_BY_DEVICE,
      chartType: 'pie',
      text: '{0} devices had the highest number of conversions with {1}.',
    },
    mostConversion_day: {
      query: TRACKER_CLICK_INSIGHTS_BY_DAY_OF_THE_WEEK,
      chartType: 'bar',
      text: '{0} generated the most conversions with {1} conversions across different hours.',
    },
    highestConversion_campaign: {
      query: MY_CAMPAIGNS_QUERY,
      chartType: '',
      text: '{0} campaign had the highest number of conversions with {1}.',
    },
    highestConversion_location: {
      query: TRACKER_CLICK_INSIGHTS_BY_CITY,
      chartType: '',
      text: '{0} had the highest number of conversions with {1}.',
    },
    highestConversionRate_campaign: {
      query: MY_CAMPAIGNS_QUERY,
      chartType: '',
      text: '{0} had the highest conversion rate of {1}%.',
    },
    highestConversion_hour: {
      query: TRACKER_CLICK_INSIGHTS_BY_HOUR_OF_THE_DAY,
      chartType: 'bar',
      text: 'The highest number of conversions, {0}, was recorded during start hour: {1}.',
    },
    averageConversionRate_allCampaigns: {
      query: MY_CAMPAIGNS_QUERY,
      chartType: '',
      text: 'The average conversion rate across all campaigns was approximately {0}%.',
    },
    highestConversionRate_device: {
      query: TRACKER_CLICK_INSIGHTS_BY_DEVICE,
      chartType: 'pie',
      text: '{0} devices had the highest conversion rate of {1}%.',
    },
  }
  const goBack = () => {
    props.changeProcess('questions', null)
  }

  return (
    <div className="grid grid-cols-6 gap-6 h-[calc(100vh-100px)]">
      <div className="flex justify-start items-end col-span-6 md:col-span-2 ml-4 mt-8 sm:ml-0 xl:ml-14 md:mt-16">
        <div className="flex gap-x-2 mb-10">
          <div
            className="flex justify-center items-center rounded-full p-2 bg-gray-100 w-14 h-14"
            onClick={goBack}
          >
            <HiReply className="w-4 h-4"></HiReply>
          </div>
          <div className="flex items-center">
            <div className=" uppercase">Go Back</div>
          </div>
        </div>
      </div>
      <div className="col-span-6 md:col-span-4 ml-4 pr-4 md:pr-16 overflow-y-scroll">
        <div className="mb-10 md:mb-20">
          <div className="inline-block px-1">
            <input
              id="empty"
              name="source"
              type="radio"
              className="insightsRadio hidden absolute"
            />
            <label
              htmlFor="empty"
              className="h-12 flex justify-center items-center text-white text-center rounded placeholder-black text-lg font-medium p-2.5 px-4 break-normal"
              style={{ background: '#491C96', opacity: '0.2' }}
            >
              <div className="h-8 w-8 mr-1"></div>
            </label>
          </div>
          {sources.map((s) => (
            <div className="inline-block px-1" key={s.id}>
              <input
                id={s.id}
                name="source"
                type="radio"
                className="insightsRadio hidden absolute"
                defaultChecked={s.id === props.queryDetails.source}
              />
              <label
                htmlFor={s.id}
                className="h-12 flex justify-center items-center bg-gray-50 text-white text-center rounded placeholder-black text-sm py-2.5 px-4 break-normal"
              >
                <img className="h-8 mr-1" src={s.image} alt={s.id}></img>
                <span className="overflow-hidden w-0 whitespace-nowrap">
                  {s.name}
                </span>
              </label>
            </div>
          ))}
        </div>
        <div className="mb-4">
          <label className="flex bg-[#D9D9D9] text-black text-left rounded placeholder-black text-lg p-2.5 px-4 break-normal w-full lg:w-2/3">
            <div className="mx-6">{props.queryDetails.question}</div>
          </label>
        </div>
        <div className="mb-2">
          <InsightResponseDetails
            questionKey={props.queryDetails.questionKey}
            response={responses[props.queryDetails.questionKey]}
          ></InsightResponseDetails>
        </div>
      </div>
    </div>
  )
}

export default InsightResponse
